import '../../App.scss'
import React, { Component } from 'react'

export default class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: ['']
        };
    }
    componentDidMount() {
        this.setState({

        })
        // console.log(collection)
    }
    render() {

        return (
            <div className="">
               <p>This page will be an "ABOUT AHRF" Page</p>
               <p>Explorers and researchers alike are constantly making new and exciting historical discoveries.  Piece by piece the puzzle of the past comes together, providing a better understanding of the complex history of our world.  Founded in 2004, The Ancient Historical Research Foundation was created to research, locate, organize and document historic and ancient history as it comes into view.  Societal biases, personal agendas among the academic community and layman alike, disinformation, and misinformation have had a tremendous influence on the way humans in general view the past.  Our goal is to discover the truth, where ever it may lead ...</p>

            </div>
        );
    }
}
